import React from 'react';
import { useNavigate } from 'react-router-dom';
import MarketplaceShell from './MarketplaceShell';
import { MktButton } from './marketplaceUi';
import { MARKETPLACE_HOME_PATH } from './marketplaceLinks';

/**
 * Brand 404 for unknown /marketplace/* paths. Replaces the old silent redirect
 * to /marketplace, which hid mistyped/dead links behind the use-case wizard (#78).
 */
const MarketplaceNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <MarketplaceShell maxWidth="max-w-[520px]">
      <div className="flex flex-col items-center gap-4 rounded-xl border border-black/10 bg-white p-10 text-center">
        <div className="text-[40px] font-medium leading-none text-[#111]">404</div>
        <h1 className="text-[18px] font-medium text-[#111]">Page not found</h1>
        <p className="text-[13px] leading-relaxed text-[#6b6b6b]">
          The page you’re looking for doesn’t exist or may have moved.
        </p>
        <MktButton onClick={() => navigate(MARKETPLACE_HOME_PATH)}>
          Back to the marketplace →
        </MktButton>
      </div>
    </MarketplaceShell>
  );
};

export default MarketplaceNotFound;
